module.exports = __webpack_public_path__ + "static/mg-5f11e24aaab9d676a9d82cb6b6dfc000.png";